/**
 * NAD+ Sublingual BOGO – auto-add the free gift.
 *
 * Pairs with the native AUTOMATIC Shopify "Buy X Get Y" discount ("NADSL BOGO").
 * The native discount requires the gift to be in the cart already, so this
 * script adds it and keeps it in sync with the paid NAD+ quantity.
 *
 * - Buy = NAD+ Sublingual, one-time OR subscription (paid lines).
 * - Gift = NAD+ Sublingual added as a ONE-TIME line (no selling plan), tagged
 *   with the hidden property `_bogo_gift`. Because the gift has no selling
 *   plan it is never part of the subscription, so recurring orders never get
 *   a free unit: the BOGO only happens on the first order.
 * - Gift qty always = paid NAD+ qty, capped at MAX_GIFT_QTY. Removing the
 *   paid NAD+ removes the gift.
 */
(function () {
  'use strict';

  /* ---------------- Config ---------------- */
  var VARIANT_ID = 56333797523834; // NAD+ Sublingual (handle: sl-nad)
  var PRODUCT_ID = 15560789918074;
  // Keep in sync with "Maximum number of uses" / items-per-order on the discount.
  var MAX_GIFT_QTY = 1;
  var GIFT_PROP = '_bogo_gift';
  /* ---------------------------------------- */

  var busy = false;
  var queued = false;

  function isGift(item) {
    return !!(item.properties && item.properties[GIFT_PROP]);
  }

  function isNad(item) {
    return item.variant_id === VARIANT_ID || item.product_id === PRODUCT_ID;
  }

  function post(url, body) {
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function sync() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;

    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var paidQty = 0;
        var gift = null;
        cart.items.forEach(function (item) {
          if (!isNad(item)) return;
          if (isGift(item)) gift = item; else paidQty += item.quantity;
        });

        var desired = Math.min(paidQty, MAX_GIFT_QTY);
        var current = gift ? gift.quantity : 0;
        if (desired === current) return false;

        if (gift) {
          return post('cart/change.js', { id: gift.key, quantity: desired }).then(function () { return true; });
        }
        return post('cart/add.js', {
          items: [{
            id: VARIANT_ID,
            quantity: desired,
            properties: (function () { var p = {}; p[GIFT_PROP] = 'true'; return p; })()
            // no selling_plan on purpose => one-time, first order only
          }]
        }).then(function () { return true; });
      })
      .then(function (changed) {
        // Tell the theme (cart drawer / cart page / header count) to refresh.
        if (changed) {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false, detail: { bogo: true } }));
        }
      })
      .catch(function (e) { console.log('[bogo]', e); }) // eslint-disable-line no-console
      .then(function () {
        busy = false;
        if (queued) { queued = false; sync(); }
      });
  }

  function onCartEvent(evt) {
    if (evt && evt.detail && evt.detail.bogo) return; // ignore our own event
    // Let the theme's own request settle first.
    setTimeout(sync, 300);
  }

  document.addEventListener('on:cart:add', onCartEvent);
  document.addEventListener('on:cart:change', onCartEvent);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
